import { motion } from "framer-motion";
import { ShieldCheck, GpsFix, Lock, Headset } from "@phosphor-icons/react";
import SectionEyebrow from "@/components/shared/SectionEyebrow";

const ITEMS = [
  { icon: ShieldCheck, title: "Verified drivers", desc: "ID, license and background verified independent contractors." },
  { icon: GpsFix, title: "Live GPS tracking", desc: "End-to-end visibility from pickup to drop-off, every single order." },
  { icon: Lock, title: "Secure payments", desc: "Bank-grade encryption and PCI-compliant processing across the platform." },
  { icon: Headset, title: "24/7 support", desc: "Human-first customer support in the Caribbean — chat, phone and email." },
];

export default function TrustSafety() {
  return (
    <section className="relative py-24 lg:py-32 border-t border-ih-line" data-testid="home-trust">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-12">
          <div className="lg:col-span-8 space-y-5">
            <SectionEyebrow label="Trust & safety" color="orange" />
            <h2 className="font-display font-extrabold text-4xl lg:text-6xl text-white leading-[1.02]">
              Built like infrastructure.<br />
              <span className="text-white/40">Operated</span> <span className="text-ih-orange">like a tech company.</span>
            </h2>
          </div>
          <p className="lg:col-span-4 text-white/60 leading-relaxed">
            Every order on IslandHop is protected by verified drivers, real-time GPS, encrypted payments and a
            support team that actually picks up.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-3">
          {ITEMS.map((it, i) => {
            const Icon = it.icon;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.5, delay: i * 0.06 }}
                data-testid={`trust-item-${i}`}
                className="relative bg-ih-surface border border-ih-line rounded-2xl p-7 hover:border-ih-orange/40 transition group overflow-hidden"
              >
                <div className="absolute top-0 right-0 w-32 h-32 ih-radial-orange opacity-0 group-hover:opacity-100 transition" />
                <Icon weight="duotone" size={26} className="text-ih-orange mb-5 relative" />
                <p className="font-display font-bold text-lg text-white mb-1.5 relative">{it.title}</p>
                <p className="text-sm text-white/55 leading-relaxed relative">{it.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
